var _defs, _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 145.87 87.57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _title || (_title = /*#__PURE__*/React.createElement("title", null, "i3")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.8,6.55A6.56,6.56,0,0,0,139.24,0L6.55.12A6.57,6.57,0,0,0,0,6.68v6.87l145.8-.14Zm0,26.92L0,33.6.08,81a6.55,6.55,0,0,0,6.55,6.55l132.69-.13a6.55,6.55,0,0,0,6.55-6.55Zm-137,16v-8.6l62.52-.06v8.6Z"
  })))));
};

export default __webpack_public_path__ + "static/media/i1.082c6dd2.svg";
export { SvgComponent as ReactComponent };